// ── NAVIGATION ──
export const NAV_LINKS = [
  { href: '/',            label: 'Home' },
  { href: '/skillnexus',  label: 'SkillNexus' },
  { href: '/internnexus', label: 'InternNexus' },
  { href: '/promptnexus', label: 'PromptNexus' },
  { href: '/ecosystem',   label: 'Ecosystem' },
  { href: '/ambassador',  label: 'Ambassador' },
]

// ── PLATFORMS ──
export const PLATFORMS = [
  {
    id: 'skillnexus',
    abbr: 'SN',
    name: 'SkillNexus',
    tagline: 'Upskilling Platform',
    color: '#6c7fcc',
    colorBg: 'rgba(108,127,204,0.12)',
    colorBorder: 'rgba(108,127,204,0.25)',
    dotColor: '#6c7fcc',
    gradient: 'linear-gradient(135deg,#E8642A,#f5945c)',
    letter: 'S',
    journeyDesc: 'Learn in-demand skills',
    ecoDesc: 'Learner upskilling — enrol in batches, consume AI-generated content, earn certificates',
    modalStatus: 'Live now',
    modalStatusBg: 'rgba(232,100,42,0.12)',
    modalStatusBorder: 'rgba(232,100,42,0.25)',
    modalStatusColor: '#f5945c',
    modalStatusDot: '#E8642A',
    modalTitle: 'SkillNexus',
    modalDesc: 'SkillNexus is live. Enrol in structured batches, access AI-generated day-wise content, and earn verified certificates.',
    modalDate: 'Live now',
    modalGiftColor: '#E8642A',
    modalGiftBg: 'rgba(232,100,42,0.08)',
    modalGiftBorder: 'rgba(232,100,42,0.2)',
    modalBtnGrad: 'linear-gradient(135deg,#E8642A,#c94e18)',
    modalBtnShadow: 'rgba(232,100,42,0.4)',
    modalBorder: 'rgba(232,100,42,0.3)',
    description: 'The learner-facing upskilling platform where students enrol in structured batches, consume AI-generated day-wise content, attend live mentored sessions, and earn verified certificates.',
    features: [
      'Browse and enrol in batches across Data Science, Web Dev, AI/ML, Cybersecurity, and more',
      'Day-wise structured content with video, quizzes, and project submissions',
      'One-click MS Teams live sessions with mentors',
      'Auto-graded quizzes and detailed progress dashboards',
      'LinkedIn-shareable PDF certificates on completion',
    ],
    stats: [
      { val: '752+', label: 'Courses available' },
      { val: '25',   label: 'Course groups' },
      { val: '4',    label: 'Learning levels' },
      { val: 'PWA',  label: 'Mobile-first design' },
    ],
    cta: { primary: 'Explore SkillNexus', secondary: 'Start Learning' },
    url: 'https://sn.nexusaiweb.com',
  },
  {
    id: 'internnexus',
    abbr: 'IN',
    name: 'InternNexus',
    tagline: 'Internship Platform',
    color: '#22d3ee',
    colorBg: 'rgba(8,145,178,0.12)',
    colorBorder: 'rgba(34,211,238,0.25)',
    dotColor: '#22d3ee',
    gradient: 'linear-gradient(135deg,#0891b2,#22d3ee)',
    letter: 'I',
    journeyDesc: 'Real-world internships',
    ecoDesc: 'Internship placement with real companies, mentor oversight, and career-ready credentials',
    modalStatus: 'Live now',
    modalStatusBg: 'rgba(8,145,178,0.12)',
    modalStatusBorder: 'rgba(34,211,238,0.2)',
    modalStatusColor: '#22d3ee',
    modalStatusDot: '#22d3ee',
    modalTitle: 'InternNexus',
    modalDesc: 'InternNexus is live. Get matched with real 4–6 week company projects, guided by expert mentors, and earn career-ready credentials.',
    modalDate: 'Live now',
    modalGiftColor: '#22d3ee',
    modalGiftBg: 'rgba(8,145,178,0.08)',
    modalGiftBorder: 'rgba(34,211,238,0.15)',
    modalBtnGrad: 'linear-gradient(135deg,#0891b2,#22d3ee)',
    modalBtnShadow: 'rgba(8,145,178,0.4)',
    modalBorder: 'rgba(34,211,238,0.2)',
    description: 'The internship placement layer that bridges training and employment. Companies post real 4–6 week projects, students apply post-training, and mentors oversee every deliverable.',
    features: [
      'Companies post real-world 4–6 week live projects',
      'Students apply directly after completing SkillNexus training',
      'Mentor-supervised project delivery with milestone tracking',
      'Company-rated completion certificates tied to your profile',
      'Direct pathway to JobNexus for full-time placement',
    ],
    howItWorks: [
      { title: 'Complete training on SkillNexus', sub: 'Build skills, earn credentials' },
      { title: 'Apply to company projects',       sub: '4–6 week live industry projects' },
      { title: 'Work under mentor oversight',     sub: 'Guided project delivery' },
      { title: 'Earn internship certificate',     sub: 'Company-rated completion record' },
    ],
    cta: { primary: 'Explore InternNexus', secondary: 'Browse Internships' },
    url: 'https://in.nexusaiweb.com',
  },
  {
    id: 'promptnexus',
    abbr: 'PN',
    name: 'PromptNexus',
    tagline: 'AI Challenge Platform',
    color: '#f5945c',
    colorBg: 'rgba(232,100,42,0.12)',
    colorBorder: 'rgba(232,100,42,0.25)',
    dotColor: '#E8642A',
    gradient: 'linear-gradient(135deg,#1C2D5E,#3a5cb8)',
    letter: 'P',
    journeyDesc: 'AI challenges & hackathons',
    ecoDesc: 'Hackathons and AI challenges — compete, win, and get noticed by top companies',
    description: 'The hackathon and AI challenge platform where students and professionals compete, innovate, and showcase skills through structured AI-powered competitions and real-world challenges.',
    features: [
      'Host and participate in AI hackathons and prompt engineering challenges',
      'Compete in structured, time-bound project challenges with real judges',
      'Showcase winning projects to partner companies and recruiters',
      'Earn NexusCoins and platform recognition for top performers',
    ],
    challengeTypes: [
      { icon: '⚡', title: 'AI Hackathons',        sub: '24–72 hour intensive builds',      bg: 'rgba(232,100,42,0.2)' },
      { icon: '🎯', title: 'Prompt Challenges',    sub: 'Engineer better AI prompts',       bg: 'rgba(108,127,204,0.2)' },
      { icon: '🏆', title: 'Industry Competitions',sub: 'Sponsored by partner startups',    bg: 'rgba(108,127,204,0.2)' },
      { icon: '📊', title: 'Case Study Sprints',   sub: 'Real business problem solving',    bg: 'rgba(34,211,238,0.15)' },
    ],
    cta: { primary: 'Join a Challenge', secondary: 'Host a Hackathon' },
    url: 'https://pn.nexusaiweb.com',
  },
]

// ── PLATFORM DEEP-DIVE CONTENT (drives /skillnexus, /internnexus, /promptnexus detail sections) ──
// Numbers below are sourced from each platform's own landing experience — keep them in sync.
export const PLATFORM_DETAIL = {
  skillnexus: {
    overview:
      'SkillNexus is where the NexusAI journey begins. Enrol in expertly curated, day-wise batches, learn from AI-generated content that stays current with industry, get your code and projects graded by AI in seconds, and walk away with a verified certificate that automatically strengthens your NexusAI profile — feeding straight into InternNexus matching.',
    stats: [
      { val: '752+',   label: 'Programs available',            note: 'Across 25 course groups' },
      { val: '3.2s',   label: 'Avg AI code-grading time',      note: 'Instant, actionable feedback' },
      { val: '99.4%',  label: 'Grading accuracy vs humans',    note: 'Benchmarked against expert reviewers' },
      { val: '+34%',   label: 'Faster skill improvement',      note: 'For learners using AI feedback' },
    ],
    pillars: [
      { icon: '📚', title: 'Structured Batch Learning', desc: 'Enrol in curated batches with day-wise content so you make consistent, measurable progress instead of drifting through scattered tutorials.' },
      { icon: '🤖', title: 'AI-Generated Content', desc: 'Lessons, slides, videos, quizzes and projects generated by GPT-4.1 — refreshed to reflect current industry standards, not last decade’s syllabus.' },
      { icon: '⚡', title: 'AI Code Grader', desc: 'Submit your project and get scored on readability, best practices, test coverage, security and performance in ~3.2 seconds.' },
      { icon: '🎥', title: 'Live Mentor Sessions', desc: 'One-click Microsoft Teams sessions with experienced mentors who unblock you and review your work in real time.' },
      { icon: '📈', title: 'A Profile That Upgrades Itself', desc: 'Every completed course and certificate strengthens your NexusAI profile automatically — powering InternNexus internship matches.' },
      { icon: '📜', title: 'Verified Certificates', desc: 'LinkedIn-shareable PDF certificates on completion, recognised by our partner companies.' },
    ],
    journey: [
      { title: 'Learn the skill',                 desc: 'Day-wise structured content + live mentored sessions.' },
      { title: 'Earn your certificate',           desc: 'Auto-graded quizzes and AI-reviewed projects.' },
      { title: 'Profile upgrades automatically',  desc: 'Skills sync to your single NexusAI identity.' },
      { title: 'AI matches you to internships',   desc: 'InternNexus surfaces live roles that fit your new skills.' },
    ],
    audience: [
      { icon: '🎓', title: 'College Students', desc: 'Earn NEP 2020 / NSQF-aligned, credited skills before you graduate.' },
      { icon: '💼', title: 'Working Professionals', desc: 'Upskill into AI, data and cloud roles around your schedule.' },
      { icon: '🔄', title: 'Career Switchers', desc: 'Structured, beginner-to-advanced paths into a new field.' },
      { icon: '🏫', title: 'Colleges & Institutions', desc: 'Run entire student batches with dashboards and reporting.' },
    ],
    faqs: [
      { q: 'Is SkillNexus live?', a: 'Yes — SkillNexus is live at sn.nexusaiweb.com. Sign up, enrol in a batch, and start learning today.' },
      { q: 'Do I need a separate account for each platform?', a: 'No. One NexusAI login works across SkillNexus, InternNexus and PromptNexus — switch from the product switcher.' },
      { q: 'Are the certificates recognised?', a: 'Yes. Certificates are LinkedIn-shareable and recognised by our partner companies, and align with NEP 2020 / NSQF frameworks.' },
      { q: 'Can my college enrol a whole batch?', a: 'Yes. Colleges can enrol student batches and track progress, attendance and outcomes from a dedicated dashboard.' },
    ],
  },

  internnexus: {
    overview:
      'InternNexus is the bridge between training and employment. After building skills on SkillNexus, our AI matching engine connects you to real 4–6 week company projects — not simulations. Every deliverable is supervised by a domain-expert mentor, your completion certificate is company-rated, and top performers get a direct line to full-time placement via JobNexus.',
    stats: [
      { val: '70%',     label: 'Interns convert to full-time', note: 'NACE — return-offer rate for paid interns' },
      { val: '1 Cr',    label: 'Internships by 2026',          note: 'PM Internship Scheme · top 500 companies' },
      { val: '100%',    label: 'UG degrees need internships',  note: 'NEP 2020 + NSQF experiential learning' },
      { val: '3×',      label: 'Higher callback rate',         note: 'With real project experience vs coursework only' },
    ],
    pillars: [
      { icon: '🏢', title: 'Real Company Projects', desc: 'Actual 4–6 week deliverables for real startups and companies — not practice problems or simulations.' },
      { icon: '🧠', title: 'AI Matching Engine', desc: 'Continuously scans 1,240+ live internships and matches them to your verified skills, refreshing as your profile grows.' },
      { icon: '🧑‍🏫', title: 'Expert Mentor Oversight', desc: 'A domain expert supervises every project, reviews milestones, and keeps you accountable to a professional standard.' },
      { icon: '🏆', title: 'Company-Rated Certificates', desc: 'Your completion certificate is co-signed and rated by the company — real credibility tied to your profile.' },
      { icon: '🔗', title: 'JobNexus Pipeline', desc: 'Top performers earn a direct referral into JobNexus for full-time placement opportunities.' },
      { icon: '🏫', title: 'Offline TechHubs', desc: 'Tier-2/3/4 innovation labs in Patna & Saharsa bring AI internships within reach of every region.' },
    ],
    journey: [
      { title: 'Complete training on SkillNexus', desc: 'Build skills and earn verified credentials.' },
      { title: 'Apply to company projects',       desc: 'AI matches you to live 4–6 week industry roles.' },
      { title: 'Work under mentor oversight',     desc: 'Milestone-tracked, guided project delivery.' },
      { title: 'Earn your internship certificate',desc: 'Company-rated completion record on your profile.' },
    ],
    audience: [
      { icon: '🎓', title: 'Post-Training Students', desc: 'Turn freshly-learned skills into real, credited work experience.' },
      { icon: '🏫', title: 'Colleges', desc: 'Meet NEP 2020 internship-credit requirements at scale.' },
      { icon: '🏢', title: 'Companies', desc: 'Post real projects and discover pre-vetted, mentor-guided talent.' },
      { icon: '🌍', title: 'Tier-2/3/4 Youth', desc: 'Access remote-first internships regardless of where you live.' },
    ],
    faqs: [
      { q: 'Is InternNexus live?', a: 'Yes — InternNexus is live at in.nexusaiweb.com. Apply to real company projects and get matched with mentors today.' },
      { q: 'Do I need to finish training first?', a: 'Completing a SkillNexus track is strongly recommended — it builds the verified skills the AI matching engine uses to place you.' },
      { q: 'Are these real internships?', a: 'Yes. Companies post genuine 4–6 week live projects with real deliverables, supervised by expert mentors.' },
      { q: 'Is it remote?', a: 'Yes — projects are fully remote with async collaboration tools, plus optional support from our offline TechHubs.' },
    ],
  },

  promptnexus: {
    overview:
      'PromptNexus is where AI skills meet real competition. Learn prompt engineering on structured PromptPath tracks, sharpen exam and interview prep with ExamNexus, then test yourself in the Arena — write a prompt, get scored instantly by NexusEval, and climb the leaderboard. Win cash prizes, NexusCoins and LinkedIn-verified recognition along the way.',
    stats: [
      { val: '92M+',    label: 'Indians using GenAI monthly',  note: 'The fastest-growing skill in the country' },
      { val: '2.3×',    label: 'Higher productivity',          note: 'With well-crafted prompts' },
      { val: '₹1.5L Cr',label: 'AI economic impact by 2030',   note: 'Projected for India' },
      { val: '₹50K',    label: 'In cash prizes',               note: 'Top challenge rewards, up to ₹50,000' },
    ],
    pillars: [
      { icon: '🛤️', title: 'PromptPath Learning', desc: 'Structured tracks, modules and submodules with XP and levels — progress from beginner to Master Architect.' },
      { icon: '⚔️', title: 'The Arena', desc: 'Compete in live challenges: read the problem, write your prompt, let the AI evaluate, and level up.' },
      { icon: '🤖', title: 'NexusEval Feedback', desc: 'Every submission is scored instantly by AI with specific, actionable guidance to polish your prompts.' },
      { icon: '🎓', title: 'ExamNexus Tracks', desc: 'Targeted prep for NEET/JEE, UPSC/SSC/Banking, technical + HR interviews, and web development launchpads.' },
      { icon: '🏆', title: 'Real Rewards', desc: 'Cash prizes up to ₹50,000, redeemable NexusCoins, and LinkedIn-verified certificates for top performers.' },
      { icon: '📊', title: 'Tracks & Leaderboards', desc: 'Climb global and challenge leaderboards, build a public track record, and get noticed by hiring partners.' },
    ],
    journey: [
      { title: 'Register & set goals',     desc: 'Free to start — pick your tracks and targets.' },
      { title: 'Learn on PromptPath',      desc: 'Structured modules build real prompt-engineering skill.' },
      { title: 'Craft & submit prompts',   desc: 'Solve real problem briefs in the editor.' },
      { title: 'Get NexusEval feedback',   desc: 'Instant AI scoring tells you exactly how to improve.' },
      { title: 'Compete & win in the Arena',desc: 'Climb leaderboards, earn rewards, get noticed.' },
    ],
    audience: [
      { icon: '🎓', title: 'Students', desc: 'Build the #1 skill recruiters now screen for, early.' },
      { icon: '📝', title: 'Exam Aspirants', desc: 'NEET/JEE, UPSC, SSC and Banking prep, powered by AI.' },
      { icon: '💼', title: 'Job Seekers', desc: 'Ace technical and HR interviews with guided practice.' },
      { icon: '🧑‍💻', title: 'Professionals', desc: 'Turn prompt fluency into 2.3× everyday productivity.' },
    ],
    faqs: [
      { q: 'Is PromptNexus free?', a: 'Yes — it’s free to start. You can learn on PromptPath and enter challenges without paying.' },
      { q: 'Are the prizes real?', a: 'Yes. Top challenges award real cash prizes (up to ₹50,000), NexusCoins, and LinkedIn-verified certificates.' },
      { q: 'What is NexusEval?', a: 'NexusEval is the AI engine that scores your prompts instantly and gives specific feedback so you improve every attempt.' },
      { q: 'What is ExamNexus?', a: 'A set of focused PromptPath tracks for NEET/JEE, UPSC/SSC/Banking, interview prep, and web development.' },
    ],
  },
}

// ── ECOSYSTEM CONNECTIVE TISSUE (drives the /ecosystem story) ──
export const ECOSYSTEM_PILLARS = [
  { icon: '🔐', title: 'One Identity', desc: 'A single NexusAI login works across SkillNexus, InternNexus and PromptNexus. No re-registering, no juggling passwords.' },
  { icon: '🪙', title: 'Shared Currency', desc: 'Earn GNC / NexusCoins anywhere in the ecosystem and spend them anywhere — rewards that compound across platforms.' },
  { icon: '🧠', title: 'A Profile That Follows You', desc: 'Skills you earn on SkillNexus power InternNexus matching and unlock PromptNexus tracks — your progress is never siloed.' },
  { icon: '🧑‍🏫', title: 'Shared Mentor Network', desc: 'The same vetted expert mentors guide you through learning, internships and challenges for a consistent experience.' },
  { icon: '📊', title: 'Unified Dashboard', desc: 'Track courses, internships, challenges, certificates and coins from one place — your entire journey at a glance.' },
  { icon: '🚀', title: 'One Continuous Journey', desc: 'Learn → Intern → Compete → Get placed. Each platform hands you off seamlessly to the next stage of your career.' },
]

export const ECOSYSTEM_FLYWHEEL = [
  { num: '01', platform: 'SkillNexus',  title: 'You learn',   desc: 'Master in-demand skills with AI-generated content and live mentors.', color: '#6c7fcc' },
  { num: '02', platform: 'InternNexus', title: 'You apply',   desc: 'AI matches your verified skills to real company internships.',     color: '#22d3ee' },
  { num: '03', platform: 'PromptNexus', title: 'You compete', desc: 'Sharpen and prove your edge in AI challenges and the Arena.',       color: '#f5945c' },
  { num: '04', platform: 'JobNexus',    title: 'You get placed', desc: 'Certificates, projects and a track record that get you hired.',   color: '#68c49a' },
]

// ── STATS ──
export const SITE_STATS = [
  { val: '25+',  label: 'Course Groups Supported' },
  { val: '752+', label: 'Programs Available' },
  { val: '3',    label: 'Active Platforms' },
  { val: '1',    label: 'Login for Everything' },
]

// ── STUDENT JOURNEY ──
export const STUDENT_JOURNEY = [
  { num: '1', name: 'Register',        desc: 'One account for all three platforms',   color: '#E8642A', bg: 'rgba(232,100,42,0.15)' },
  { num: '2', name: 'Choose your path',desc: 'Data Science, AI/ML, Web Dev...',       color: '#E8642A', bg: 'rgba(232,100,42,0.15)' },
  { num: '3', name: 'Enrol & Learn',   desc: 'Day-wise content on SkillNexus',        color: '#E8642A', bg: 'rgba(232,100,42,0.15)' },
  { num: '4', name: 'Intern & Build',  desc: 'Real projects via InternNexus',         color: '#E8642A', bg: 'rgba(232,100,42,0.15)' },
  { num: '5', name: 'Compete',         desc: 'AI challenges on PromptNexus',          color: '#E8642A', bg: 'rgba(232,100,42,0.15)' },
  { num: '6', name: 'Get Placed',      desc: 'Job-ready with certificates & projects',color: '#68c49a', bg: 'rgba(68,196,154,0.15)' },
]

// ── FOOTER LINKS ──
export const FOOTER_LINKS = [
  { label: 'Privacy Policy',  href: '/privacy' },
  { label: 'Terms of Service',href: '/terms' },
  { label: 'Ambassador',      href: '/ambassador' },
  { label: 'Contact',         href: 'mailto:support@nexusaiweb.com' },
  { label: 'About',           href: '/ecosystem' },
]

// Same handles as SkillNexus/PromptNexus — one NexusAI/TechIntelliVerse brand presence.
export const SOCIAL_LINKS = [
  { label: 'Instagram', href: 'https://www.instagram.com/nexusai.india/' },
  { label: 'LinkedIn',  href: 'https://www.linkedin.com/company/nexusaiweb/' },
  { label: 'Facebook',  href: 'https://www.facebook.com/nexusaiweb/' },
  { label: 'YouTube',   href: 'https://www.youtube.com/@internnexus' },
]

// ── OFFLINE CENTRES (sourced from uat.internnexus.com) ──
export const OFFLINE_CENTRES = [
  {
    name:    'InternNexus TechHub — Patna',
    tier:    'Tier-2 Hub',
    city:    'Patna, Bihar',
    pincode: '800010',
    address: '2nd Floor, R-HUB, Sadaquat Ashram, Kurji, Patna, Bihar — 800010',
    phone:   '+91 9205-9191-24',
    tag:     'AIC Bihar Vidyapeeth · AI & Data Science Labs',
    color:   '#E8642A',
    mapUrl:  'https://maps.app.goo.gl/WgPgg8Jjqt463jxX8',
  },
  {
    name:    'InternNexus TechHub — Saharsa',
    tier:    'Tier-3 / Tier-4 Hub',
    city:    'Saharsa, Bihar',
    pincode: '852201',
    address: 'Near SBI ATM, Block Road, Refugee Colony, Saharsa, Bihar — 852201',
    phone:   '+91 9205-9191-25',
    tag:     "Bihar's First AI-Enabled Innovation Lab · Koshi Region",
    color:   '#22d3ee',
    mapUrl:  'https://maps.app.goo.gl/BYKwMFu99FQ4JpBP8',
  },
]

// ── HEAD OFFICE ──
export const HEAD_OFFICE = {
  address: 'L-9/826, 4th Floor, Mehrauli, New Delhi — 110030',
  phone:   '+91 9205-9191-24',
  email:   'support@nexusaiweb.com',
}

// ── VERIFIED STUDENT TESTIMONIALS (LinkedIn + Google Reviews) ──
export const TESTIMONIALS = [
  {
    name:    'Nipun Rajpal',
    company: 'HCL Technologies',
    batch:   'Batch 2023 · ITA L3 Program',
    source:  'Google',
    when:    '1 year ago',
    rating:  5,
    initials:'NR',
    image:   '/success-stories/nipun-rajpal.png',
    text:    'I would like to express my gratitude to Mr. Piyush Pandey and the InternNexus team for their excellent support, and their guidance significantly contributed to my positive learning experience. I appreciate the efforts put forth by Mr. Piyush Pandey in mentoring me, and his assistance was invaluable.',
  },
  {
    name:    'Jaskaran Singh',
    company: 'Infosys',
    batch:   'Batch 2024 · ITA L2 Program',
    source:  'LinkedIn',
    when:    '8 months ago',
    rating:  5,
    initials:'JS',
    image:   '/success-stories/jaskaran-singh.png',
    text:    'I engaged in a MERN Stack program under the guidance of Mr. Piyush Pandey as my mentor. The InternNexus team played a crucial role in assisting me to acquire valuable skills essential for this domain.',
  },
  {
    name:    'Lucky Singh',
    company: 'Reservation Data Maintenance',
    batch:   'Batch 2023 · ITA L3 Program',
    source:  'Google',
    when:    '3 weeks ago',
    rating:  5,
    initials:'LS',
    image:   '/success-stories/lucky-singh.png',
    text:    "Thoroughly enjoyed the course with Piyush Sir! His expertise and clear knowledge on the subjects made a significant impact. Despite usually struggling to maintain focus in lengthy lectures, I was pleasantly surprised at how engaged I remained throughout the course under his guidance. The incorporation of real-world examples was a definite plus.",
  },
  {
    name:    'Dhanoj Kumar',
    company: 'Genpact India Private Limited',
    batch:   'Batch 2024 · ITA L2 Program',
    source:  'Google',
    when:    '7 months ago',
    rating:  5,
    initials:'DK',
    image:   '/success-stories/dhanoj-kumar.png',
    text:    'All aspects were commendable with Piyush Sir and the InternNexus team. Their outstanding support and guidance played a pivotal role in creating a favorable learning environment. I am grateful for his mentorship and the invaluable aid provided by the InternNexus team.',
  },
  {
    name:    'Neeraj Kumar',
    company: 'Baazi Games Pvt Ltd',
    batch:   'Batch 2024 · ITA L3 Program',
    source:  'LinkedIn',
    when:    '2 weeks ago',
    rating:  5,
    initials:'NK',
    image:   '/success-stories/neeraj-kumar.png',
    text:    'The explanation was superb, guiding from fundamental concepts to advanced understanding, enriched by hands-on practice and live project experiences. It was a comprehensive and engaging learning journey.',
  },
]

// ── TECH PARIVARTAN BIHAR (Tier-2/3/4 flagship initiative) ──
export const TECH_PARIVARTAN = {
  tagline:    "जब तक हर युवा तक तकनीक नहीं पहुंचती, हम नहीं रुकेंगे!",
  taglineEn:  "We won't stop until technology reaches every youth in Tier-2, 3 & 4 cities.",
  stats: [
    { val: '100K+', label: 'Students trained since 2017'   },
    { val: '10K+',  label: 'Tier-2/3/4 students empowered' },
    { val: '2',     label: 'TechHub centres in Bihar'      },
    { val: '50+',   label: 'Industry mentors onboarded'    },
    { val: '20+',   label: 'Community events organised'    },
    { val: '10+',   label: 'College MoUs signed'           },
    { val: '8',     label: 'Indian languages supported'    },
    { val: '95%',   label: 'Placement success rate'        },
  ],
  languages: ['हिंदी', 'English', 'मैथिली', 'भोजपुरी', 'বাংলা', 'मराठी', 'తెలుగు', 'தமிழ்'],
  recognitions: [
    { label: 'STPI CHUNAUTI 3.0',         by: 'Software Technology Parks of India' },
    { label: 'Bihar Start-Up Hub',        by: 'Dept. of IT, Govt. of Bihar' },
    { label: 'EdTech Recognition 2021',   by: 'Bihar State Government' },
    { label: "Top 20 Prototypes",         by: 'Govt. of Jharkhand' },
    { label: 'Startup India',             by: 'DPIIT' },
    { label: 'MSME Registered',           by: 'Ministry of MSME' },
  ],
}
